import React from 'react';

import promotion_config from '../../../promotion_config';
import { EntryForm } from './entry_form';
import Error from './error';

import ticketSample from './ticket-sample.png';

import './style.scss';

export const EntryInner = ({ entry, drawTicket, game, animation, actions }) => {
    return (
        <div className="entry-div">
            <div className="flush-row">
                <div className="entry-info">
                    <div className="description">
                        <p>
                            Enter the 2nd Chance App Code from one (1) eligible
                            non-winning 2020 holiday-themed Scratch ticket where
                            indicated in the space below.
                        </p>
                    </div>
                </div>

                <div id="entry-alert" className="entry-alert">
                    <Error drawTicket={drawTicket} actions={actions} />
                </div>

                <div className="entry-container">
                    <div className="entry-panel">
                        <EntryForm
                            promotion_id={promotion_config.promotion_id}
                            promotion={promotion_config.promotion}
                            appUrl={promotion_config.appUrl}
                            drawTicket={drawTicket}
                            entry={entry}
                            game={game}
                            animation={animation}
                            actions={actions}
                            createfunc={
                                actions.drawTicketActions.enterDrawTicket
                            }
                        />
                    </div>
                </div>

                <div className="entry-container">
                    <div className="entry-panel">
                        <h3>
                            <strong>
                                ENTRY THE 8-DIGIT ALPHA-NUMERIC CODE ON FRONT
                            </strong>
                        </h3>
                        <img
                            src={ticketSample}
                            alt="Ticket Sample"
                            className="img-fluid d-block mx-auto"
                        />
                    </div>
                </div>

                <div className="lottery-message w-100">
                    <h2>IMPORTANT! HOLD ONTO YOUR TICKET(S).</h2>
                    <h4>
                        YOU WILL NEED TO PRESENT IT TO IDAHO LOTTERY OFFICIALS
                        IF YOU ARE SELECTED AS A WINNER.
                    </h4>
                </div>
            </div>
        </div>
    );
};

export default EntryInner;
